module.exports = __webpack_public_path__ + "img/wechat.ce167c67.svg";